'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Illustration, IllustrationWrapper, Label } from '@components/Common';
import { TextGroup } from '@components/TextGroups';

import { ImageContainer } from '../styles';
import { IntroductionContainer } from './styles/IntroductionStep';

export const IntroductionStep: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <IntroductionContainer>
      <Label>{t('introduction')}</Label>
      <TextGroup
        header={t('onboardingTeacher.introductionTitle')}
        paragraph={t('onboardingTeacher.introductionDescription')}
      />
      <ImageContainer>
        <IllustrationWrapper>
          <Illustration
            priority
            fill
            src={'/assets/images/Illustration-people.svg'}
            alt={'Illustration-people'}
          />
        </IllustrationWrapper>
      </ImageContainer>
    </IntroductionContainer>
  );
};
